Apt.fn.make('properties.state', {
	/**
	 * Setup module
	 *
	 * @param {Object} options
	 * @returns {Object}
	 */
	init(options) {
		const scope = this;
		const priv = scope.$private;

		priv.conf = options;
		priv.uid = LS.util.uid();

		// Merge state when user data is available
		$.observe('user', data => {
			if (data && data.account) {
				priv.merge();
			}
		}, {
			init: true,
			namespace: priv.uid,
			recursive: true
		});

		priv.bind();

		return scope;
	},

	/**
	 * Update state
	 */
	update() {
		this.$private.merge();
	},

	/**
	 * Add state
	 *
	 * @param {String} type
	 * @param {Number} id
	 * @param {Object} context
	 * @param {Object} [options]
	 * @param {Function} [options.success]
	 */
	add(type, id, context, options) {
		options.success = $.toArray(options.success || []);

		options.success.push((data, xhr, req) => {
			if (type === 'saves') {
				$.set('user.account.saves.' + id, (req.data ? (req.data.collection || []) : []).map(Number));

				LS.analytics.track({
					action: 'click',
					target: 'listing',
					id: id,
					category: 'save'
				}, {
					key: context.key,
					source: context.source
				});
			} else {
				$.push('user.account.hidden', id);
			}
		});

		if (type === 'saves') {
			const collections = LS.user.get('collections');

			if (collections && collections.length) {
				LS.util.load('collect', () => {
					Apt.collect.init(id, options.success);
				});

				return;
			}
		}

		this.$private.request(type, 'put', id, options);
	},

	/**
	 * Remove state
	 *
	 * @param {String} type
	 * @param {Number} id
	 * @param {Object} [context]
	 * @param {Object} [options]
	 * @param {Function} [options.error]
	 * @param {Function} [options.success]
	 */
	remove(type, id, context, options) {
		options.success = $.toArray(options.success || []);

		options.success.push((data, xhr, req) => {
			if (type === 'saves') {
				if (req.data && req.data.collection) {
					$.set('user.account.saves.' + id, req.data.collection.map(Number));
				} else {
					$.drop('user.account.saves.' + id);
				}
			} else {
				$.drop('user.account.hidden', id);
			}
		});

		options.error = null;

		if (type === 'saves') {
			const collections = LS.user.get('saves.' + id) || [];

			if (collections.length) {
				LS.util.load('collect', () => {
					Apt.collect.init(id, options.success, collections);
				});

				return;
			}
		}

		this.$private.request(type, 'delete', id, options);
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		LS.util.reset(this.$private.uid, null, null, true);
	}
}, {
	/**
	 * Apply state
	 */
	merge() {
		const conf = this.conf;
		const app = $.app[conf.app];
		const types = {
			saves: 'save',
			hidden: 'hide'
		};

		let data;
		let results;

		if (! app) {
			return;
		}

		data = LS.user.get();
		results = app.$get('results');

		if (! data || ! results) {
			return;
		}

		for (const [type, value] of Object.entries(types)) {
			if (! data[type]) {
				continue;
			}

			for (const item of Object.values(results)) {
				const id = item.id;
				const exists = type === 'saves' ?
					data[type][id] : data[type].includes(id);

				if (exists) {
					conf.events.exec($(`[data-id="${id}"]`, conf.delegate), app => {
						app.$set(value, true);
					});
				} else {
					const app = conf.events.get(id);

					if (app && app.$get([value])) {
						app.$set(value, false);
					}
				}
			}
		}
	},

	/**
	 * Bind events
	 */
	bind() {
		const scope = this;

		$.events.on('$save, $hide', 'click', (e, el) => {
			LS.user.guard(() => {
				const $preview = $(el).closest('$property');
				const id = $preview.data('id');
				const type = el.classList.contains('$save') ?
					'saves' : 'hidden';
				const data = LS.user.get(type);
				const action = Boolean(data && (type === 'saves' ?
					data[id] : data.includes(id)
				)) ? 'remove' : 'add';

				scope.$public[action](type, id, $preview.data('context'), {
					success: () => {
						scope.conf.events.exec($preview, app => {
							app.$set(type === 'saves' ? 'save' : 'hide', action === 'add');
						});
					}
				});
			});
		}, {
			delegate: scope.conf.delegate,
			namespace: scope.uid
		});
	},

	/**
	 * Make state request to API
	 *
	 * @param {String} type
	 * @param {String} method
	 * @param {Number} id
	 * @param {Object} [options]
	 * @param {Function} [options.error]
	 * @param {Function} [options.success]
	 */
	request(type, method, id, options) {
		options = Object.assign({
			auth: true,
			method: method
		}, options);

		options.namespace = this.uid;

		$.fetch.abort(this.uid);

		LS.api.request(`me/${type}/${id}`, options);
	}
});